module.exports = __webpack_public_path__ + "housingStatic/img/workbench_null.7463d4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_png/workbench_null.png
// module id = F0+w
// module chunks = 2